import React, { Dispatch, FC, SetStateAction } from 'react'

interface ProcessOverviewTasksContextType {
  taskIds: number[]
  setTaskIds: Dispatch<SetStateAction<number[]>>
}

const ProcessOverviewTasksContext = React.createContext<ProcessOverviewTasksContextType | null>(
  null
)

export const ProcessOverviewTasksProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
  const [taskIds, setTaskIds] = React.useState<number[]>([])

  return (
    <ProcessOverviewTasksContext.Provider value={{ taskIds, setTaskIds }}>
      {children}
    </ProcessOverviewTasksContext.Provider>
  )
}

export const useProcessOverviewTasks = () => {
  const context = React.useContext(ProcessOverviewTasksContext)

  if (!context)
    throw new Error('useProcessOverviewTasks must be used within a ProcessOverviewTasksProvider')

  return context
}
